import { Component } from '@angular/core';


import { Platform, AlertController } from '@ionic/angular';
/**
 * RXJS
 */
import { distinctUntilChanged } from 'rxjs/operators';

/**
 * PLUGINS
 */
import { StatusBar } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';

/**
 * =====SERVICES====
 */

import { ApiService } from './services/api.service'
import { AuthService } from './services/auth.service';
import { DatabaseService } from './services/database.service';
import { MenuService } from './services/menu.service';
import { SqliteService } from './services/sqlite.service';
import { StorageService } from './services/storage.service';
import { TranslateService } from './services/translate.service';

/**
 * TYPES TO USE
 */
type DynamicObj = {[key: string | number ] : string | number | any }
@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent {
  /**
   * bool to check if we are a web
   */
  public isWeb: boolean = false;
  /**
   * store if we have init the sql
   */
  private initPlugin: boolean;

  /**
   * store if we have init the app
   * dont let other service or pages load before all of the app
   */
  public initApp: boolean = false;

  direction = 'ltr';
  public language = { locale: '', title: ''} ;
  user:any = {};
  menuLinks : any[] = [];
  public strings: DynamicObj = {
    'global.app.Log out' : 'Log out',
  };

  public menuLayout: string = 'app';

  public showInstallButton : boolean = false;
  public installOnThisUrl : boolean = false;
  deferredPrompt : any;

  public isLocalHost : boolean = false;
  
  constructor(



    private alertCtrl : AlertController,
    private platform: Platform,


    private authService: AuthService,
    private db: DatabaseService,
    private menuService: MenuService,
    private _sqlite: SqliteService,
    private storage: StorageService,
    private translateService: TranslateService,
  ) {
    this.initializeApp();
  }

  /**
   * initialize the app when we start
   * init SQLite
   */
  async initializeApp() {
    await SplashScreen.hide();


    // console.log("🚀 ~ file: app.component.ts:40 ~ AppComponent ~ initializeApp ~ initializeApp:", "initializeApp")
    this.platform.ready().then(async () => {
      
      this._sqlite.initializePlugin().then(async (ret) => {
        
        this.initPlugin = ret;
  
        // console.log("🚀 ~ file: app.component.ts:30 ~ AppComponent ~ this._sqlite.initializePlugin ~ this._sqlite.platform:", this._sqlite.platform)
        if( this._sqlite.platform === "web") {

         //set the environment so we can have the sql-wasm in the correct location
          var getUrl = window.location;
          if( getUrl.hostname == 'localhost' || getUrl.hostname == 'aba-check.vercel.app'){
            this.isLocalHost = true;      
          }else{
            let version = 'v2024-08-22 15:14';
            console.log("🚀 ~ file: app.component.ts:111 ~ version:", version)
            console.log("🚀 ~ file: app.component.ts:108 ~ AppComponent ~ this._sqlite.initializePlugin ~ getUrl.hostname:", getUrl.hostname)
          }
          this.isWeb = true;
          // console.log("🚀 ~ file: app.component.ts:49 ~ AppComponent ~ this._sqlite.initializePlugin ~ this.isWeb:", this.isWeb)
          // console.log("🚀 ~ file: app.component.ts:51 ~ AppComponent ~ this._sqlite.initializePlugin ~ customElements:", customElements)

          await customElements.whenDefined('jeep-sqlite');
          // console.log("🚀 ~ file: app.component.ts:49 ~ AppComponent ~ this._sqlite.initializePlugin ~ this.isWeb:", this.isWeb)

          const jeepSqliteEl = document.querySelector('jeep-sqlite');
          // console.log("🚀 ~ file: app.component.ts:58 ~ AppComponent ~ this._sqlite.initializePlugin ~ jeepSqliteEl:", jeepSqliteEl)

          if(jeepSqliteEl != null) {

            await this._sqlite.initWebStore();
            // console.log("🚀 ~ file: app.component.ts:61 ~ AppComponent ~ this._sqlite.initializePlugin ~ `>>>> isStoreOpen ${await jeepSqliteEl.isStoreOpen()}`:",  await jeepSqliteEl.isStoreOpen() );
          } else {

            // console.log("🚀 ~ file: app.component.ts:62 ~ AppComponent ~ this._sqlite.initializePlugin ~ '>>>> jeepSqliteEl is null':", '>>>> jeepSqliteEl is null')
          }

          this.db.createSqlConnections();
        }else{
          //alert('call create tables non web');
          //set db loaded in service so we can execute
          //this.db.dbLoaded = true; //TODO: comment this out and try on native
          this.db.createSqlConnections();
        }
        this.initApp = true;
        
        // console.log("🚀 ~ file: app.component.ts:68 ~ AppComponent ~ this._sqlite.initializePlugin ~ `>>>> in App  this.initPlugin ${this.initPlugin}`:", `>>>> in App  this.initPlugin ${this.initPlugin}`)

        this.storage.get( 'locale' ).then( ( data )=>{
          if( data ){
            this.translateService.updateLang( data );
          }else{
            this.translateService.updateLang( 'en' );
          }
        });
  
  
        //subscribe to translate for the rtl direction
        this.translateService.direction
          .pipe( distinctUntilChanged())
          .subscribe
          ( data => {
            // console.log("🚀 ~ file: app.component.ts:146 ~ AppComponent ~ this._sqlite.initializePlugin ~ data:", data)
            this.direction = data;
          });
  
          this.translateService.languague
          .subscribe( data => {
             // console.log("AppComponent -> initializeApp -> data", data)
            this.language = { locale: data.locale, title: data.title };
  
            //tranlsate each string
            for (var key in this.strings ) {
              if (this.strings.hasOwnProperty(key)) {
                this.strings[ key ] = this.translateService.translate( key );
              }
            }
  
          });
        
        //subscibe to user object for display
        this.authService.user
          .pipe( distinctUntilChanged())
          .subscribe( data => {
            this.user = data;
        });
  
        this.menuService.menuLinks
          .pipe( distinctUntilChanged())
          .subscribe
          ( data => {
            this.menuLinks = data;
        });
  
        this.menuService.menuLayout
          .pipe( distinctUntilChanged())
          .subscribe
          ( data => {
            this.menuLayout = data;
        });


      });
    });

    this.platform.ready().then(() => {
      //this.statusBar.styleDefault();
      

      


    });
    
  }

  pwaInstallInit(){
    //if we are browser environment then change baseUrl
    if( ! this.platform.is( 'cordova' ) ){
      var getUrl = window.location;
      if( getUrl.hostname == 'costacheck.costa.co.uk' ){
        this.installOnThisUrl = true;
      }
    }

    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      this.deferredPrompt = e;
      // Update UI notify the user they can install the PWA
      this.showInstallButton = true;
    });
  }

  pwaInstallClick(){
    this.showInstallButton = false;
    //alert('click');

    this.deferredPrompt.prompt();
    this.deferredPrompt.userChoice.then((choiceResult : any) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the install prompt');
      } else {
        console.log('User dismissed the install prompt');
      }
    });
  }

      /**
  * Log out - triggers an alert with options to log out
  *
  * if you click yes then it performs [logOut()]{@link #logOut}
  */
 async signOutBtn(){

  var msgLogOut = this.translateService.translate( 'global.app.Log out' );
  var msgYes = this.translateService.translate( 'global.app.Yes' );
  var msgNo = this.translateService.translate( 'global.app.No' );
  var msgConfirm = this.translateService.translate( 'global.app.LogOutConfirm' );

  

  let alert = await this.alertCtrl.create({
      header: msgLogOut,
      message: msgConfirm,
      buttons: [
        {
          text: msgNo,
          role: 'cancel',
          handler: () => {
            // console.log('Cancel clicked');
          }
        },
        {
          text: msgYes,
          handler: () => {
          
            this.signOut();
          }
        }
      ]
    });
    await alert.present();
  }

  signOut(){
    this.authService.signout();
  }

  menuClick( method : string, args :any ){
    this.menuService.menuClick( method, args );
  }

  parentBack(){
    window.parent.postMessage( { func : "back" , message : "Back"} , window.location.origin );
        //https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage
  }
}
